<template>
    <div>
        <v-navigation-drawer
                temporary
                v-model="drawer"
                fixed
        >
            <v-list>
                <v-list-tile
                        v-for="item in menuItems"
                        :key="item.title"
                        :to="item.link"
                        :href="item.href"
                        value="true">
                    <v-list-tile-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        {{ item.title }}
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
        <v-toolbar class="primary" >
            <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-sm-and-up"></v-toolbar-side-icon>
            <v-toolbar-title>
                <router-link to="/" tag="span" style="cursor: pointer"  v-text="title"></router-link>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-xs-only">
                <v-btn
                        flat
                        v-for="item in menuItems"
                        :key="item.title"
                        :to="item.link"
                        :href="item.href">
                    <v-icon left dark>{{ item.icon }}</v-icon>
                    {{ item.title }}

                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
    </div>
</template>

<script>
    export default {
        name: 'bowling-menu',
        data () {
            return {
                clipped: false,
                drawer: false,
                fixed: false,
                items: [{
                    icon: 'bubble_chart',
                    title: 'Inspire'
                }],
                title: 'Bowling!!!'
            }
        },
        computed: {
            /**
             * Returns a list of menuItems that is contextual based on whether the user is logged in or not.
             * @returns {*[]}
             */
            menuItems () {
                let menuItems  = [
                   {
                      icon: 'supervised_user_circle',
                      title: 'Submit Outing',
                      link: '/submitOuting',
                      href: null
                   },
                   {
                      icon: 'build',
                      title: 'Management',
                      link: 'Management',
                      href: null
                   },
                   {
                      icon: 'people',
                      title: 'Bowler History',
                      link: '/bowlerHistory',
                      href: null
                   },
                   {
                      icon: 'bar_chart',
                      title: 'Team Outings',
                      link: '/teamOutings',
                      href: null
                   },
                   {
                      icon: 'bar_chart',
                      title: 'Game Editor',
                      link: '/gameEditor',
                      href: null
                   },
                ];

                return menuItems
            },
        },
    }
</script>

